import ValidService from "@/service/ValidService";

let model = {};

model.dataForm = {
  name: null,
  code: null,
  disabled: false,
};

model.validForm = {
  name: [ValidService.required, ValidService.checkMaxLength(100)],
  code: [
    ValidService.required,
    ValidService.checkSpaceString,
    ValidService.checkSpaceStringCenter,
    ValidService.checkMaxLength(50),
  ],
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "name",
  defaultSort: ["name", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      name: null,
      code: null,
      disabled: null,
    },
    valid: {},
    operator: {
      name: "$vn_text=",
      code: ":regex_i:",
      disabled: "",
    },
  },
};

export default model;
